import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import api, { formatApiError } from '@/lib/api';
import { apartmentToForm, buildApartmentCreatePayload } from '@/lib/apartmentPayload';
import { toast } from '@/components/ui/sonner';
import AdminPageShell from '@/components/admin/AdminPageShell';
import ApartmentAdminForm from '@/components/admin/ApartmentAdminForm';

export default function AdminApartmentNewPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [form, setForm] = useState(() => apartmentToForm(null));
  const [propertyManagers, setPropertyManagers] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/property-managers')
      .then((r) => setPropertyManagers(r.data || []))
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    if (!form.title.trim() || !form.address.trim()) {
      toast.error('Title and address are required');
      return;
    }
    setSaving(true);
    try {
      const res = await api.post('/apartments', buildApartmentCreatePayload(form));
      toast.success('Apartment created');
      const id = res.data?.id;
      navigate(id ? `/admin/apartments/${id}` : '/admin/apartments');
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || 'Failed to create');
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminPageShell
      testId="admin-apartment-new-page"
      maxWidth="max-w-2xl"
      title={t('admin.addApartment')}
      breadcrumbs={[
        { label: t('admin.apartments'), to: '/admin/apartments' },
        { label: t('admin.apt.addPage') },
      ]}
    >
      <ApartmentAdminForm
        form={form}
        setForm={setForm}
        propertyManagers={propertyManagers}
        saving={saving}
        onCancel={() => navigate('/admin/apartments')}
        onSave={handleSave}
        saveLabelKey="admin.apt.save"
      />
    </AdminPageShell>
  );
}
